var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtimedocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H12",
    stroke: "#42526D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H16",
    stroke: "#42526D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H9C4 3 2 5 2 10V16C2 21 4 23 9 23H15C20 23 22 21 22 16V11",
    stroke: "#42526D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3709 0.928906L17.2917 1.71224C16.8126 1.89141 16.4209 2.45807 16.4209 2.96641V6.06224C16.4209 6.55391 16.7459 7.19974 17.1417 7.49557L18.9334 8.83307C19.5209 9.27474 20.4876 9.27474 21.0751 8.83307L22.8667 7.49557C23.2626 7.19974 23.5876 6.55391 23.5876 6.06224V2.96641C23.5876 2.45391 23.1959 1.88724 22.7167 1.70807L20.6376 0.928906C20.2834 0.79974 19.7167 0.79974 19.3709 0.928906Z",
    stroke: "#42526D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7705 4.94505L19.4413 5.61589L21.233 3.82422",
    stroke: "#42526D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtimedocument);
export default __webpack_public_path__ + "static/media/ctimedocument.a147fba641a994d48a9f201098e92602.svg";
export { ForwardRef as ReactComponent };